import { authHeader } from './authHeader'

export const downloadFile = async (
  url: string,
  defaultFileName: string,
  errorMessage: string,
  fileName?: string,
): Promise<void> => {
  try {
    const { accessToken } = await authHeader()
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error(`Error al descargar: ${response.status} ${response.statusText}`)
    }

    // Convertir la respuesta a blob
    const blob = await response.blob()

    // Crear URL temporal para el blob
    const blobUrl = globalThis.URL.createObjectURL(blob)

    // Crear enlace temporal y activar descarga
    const link = document.createElement('a')

    let downloadName = fileName ?? defaultFileName

    const contentDisposition = response.headers.get('Content-Disposition')

    if (contentDisposition) {
      // Formato 1 (moderno, soporta acentos): filename*=UTF-8''Reporte%20final.xlsx
      const filenameStarRegex = /filename\*=UTF-8''([^;\n]+)/
      let match = filenameStarRegex.exec(contentDisposition)

      if (match?.[1]) {
        downloadName = decodeURIComponent(match[1]) // %20 → espacio, etc.
      } else {
        // Formato 2 (clásico): filename="Reporte.xlsx"
        const filenameRegex = /filename="?([^";]+)"?/

        match = filenameRegex.exec(contentDisposition)
        if (match?.[1]) {
          downloadName = match[1].trim()
        }
      }
    }

    link.href = blobUrl
    link.download = downloadName
    document.body.appendChild(link)
    link.click()

    // Limpiar recursos
    link.remove()
    globalThis.URL.revokeObjectURL(blobUrl)
  } catch (error) {
     
    console.error(errorMessage, error)
    throw error
  }
}
